import { render, staticRenderFns } from "./inputAttachment.vue?vue&type=template&id=7c6a7972&scoped=true&"
import script from "./inputAttachment.vue?vue&type=script&lang=js&"
export * from "./inputAttachment.vue?vue&type=script&lang=js&"
import style0 from "./inputAttachment.vue?vue&type=style&index=0&id=7c6a7972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6a7972",
  null
  
)

export default component.exports